import * as React from 'react';

import * as styles from './styles.css';
import { CollapsedBlock, ICollapsedButtonProps } from '../CollapsedBlock';
import { Section } from '../Section';

export interface IPromosProps extends React.PropsWithChildren {
  banner: React.ReactElement;
  Button: React.ComponentType<ICollapsedButtonProps>;
  defaultOpened?: boolean;
  onChangeOpen(opened: boolean): void;
  title: string;
}

export const Promos: React.FC<IPromosProps> = ({ banner, defaultOpened, title, children, Button, onChangeOpen }) => {
  return (
    <Section data-nav-tab="promoList/Акции" id="promoList" title={title}>
      {banner}
      <div className={styles['promos-list']}>
        <CollapsedBlock collapsedHeight={100} Button={Button} onChangeOpen={onChangeOpen} opened={defaultOpened}>
          <div className={styles['container']}>{children}</div>
        </CollapsedBlock>
      </div>
    </Section>
  );
};
